export class HeadHelper {
    public static removeDefaultCanonical(): void {
        const canonicalTag = document.querySelector('[rel="canonical"]');
        if (canonicalTag && !canonicalTag.getAttribute('data-react-helmet')) {
            if (typeof canonicalTag.remove == 'function') {
                canonicalTag.remove();
            } else {
                canonicalTag.parentElement?.removeChild(canonicalTag);
            }
        }
    }
}
